import React, { useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby'
import {
    LayoutDashboard,
    BookOpen,
    User,
    LogOut,
    GraduationCap,
    Menu,
    X
} from 'lucide-react'
import { useAuth } from '@src/contexts/AuthContext'
import * as classes from './index.module.css'
import PropTypes from 'prop-types';
import Logo from '../logo';
import { useTranslation } from 'react-i18next'; // Appended import

const UserLayout = ({children, ...props}) => {
    const { t } = useTranslation(); // Declaration of 't'
    const { logout, userProfile } = useAuth()
    const [menuToggle, setMenuToggle] = useState(false);

    const handleLogout = async () => {
        await logout()
        navigate('/login')
    }

    useEffect(() => {
        window.addEventListener("gatsby:routeUpdated", ()=> {
            setMenuToggle(false)
        });
    }, []);

    return (
        <>
        <div className="min-h-screen flex flex-col">
            <div className={classes.header}>
                <div className={classes.cont}>
                    <div className={classes.logoContainer}>
                        <Logo className={classes.logo}/>
                    </div>
                    <ul className={`${classes.menu} ${menuToggle ? classes.menuOpened : ''}`}>
                        <li className={classes.menuItem}>
                            <Link to="/user" className={classes.link}>
                                <LayoutDashboard className={classes.icon}/>
                                {t('Dashboard')}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/user/courses" className={classes.link}>
                                <BookOpen className={classes.icon}/>
                                {t('My Courses')}
                            </Link>
                        </li>
                        <li className={classes.menuItem}>
                            <Link to="/user/setting" className={classes.link}>
                                <User className={classes.icon}/>
                                {t('Settings')}
                            </Link>
                        </li>
                        <li className={`${classes.menuItem} lg_hidden mt-auto`}>
                            <button type="button" onClick={handleLogout} className={classes.link}>
                                <LogOut className={classes.icon}/>
                                {t('Logout')}
                            </button>
                        </li>
                    </ul>
                    <div className={classes.rightSecion}>
                        <span className={classes.name}>{t('Welcome back, {{fullName}}', { fullName: userProfile?.fullName })}</span>
                        <button type="button" onClick={handleLogout} className={classes.btn}>
                            <LogOut />
                            {t('Logout')}
                        </button>
                    </div>
                    <button className={classes.menuToggle} onClick={() => setMenuToggle(!menuToggle)} type="button">
                        {menuToggle ?
                            <X />
                            :
                            <Menu />
                        }
                    </button>
                </div>
            </div>
            <div className={classes.content}>
                {!userProfile?.status &&
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6" role="alert">
                        <span className="block text-sm">{t('Your Account Still Deactivated! Please contact customer service.')}</span>
                    </div>
                }
                {children}
            </div>
            <div className={classes.copyRights}>All rights reserved. © 2025 greatsweb.com.</div>
        </div>
        </>
    );
};

UserLayout.propTypes = {
    // Define prop types if necessary, e.g., children: PropTypes.node.isRequired
};

export default UserLayout;